import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CstemapiService } from '../cstemapi.service';
import { AuthService } from '../auth.service';
import { Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { MatStepper } from '@angular/material';
import { Options } from 'ng5-slider';
import * as $ from 'jquery';
import { validateHorizontalPosition } from '@angular/cdk/overlay';
declare var Highcharts: any;

@Component({
  selector: 'app-appinputs',
  templateUrl: './appinputs.component.html',
  styleUrls: ['./appinputs.component.scss']
})
export class AppinputsComponent implements OnInit {
  flag: boolean = false;
  stepperIndex: any = 0;
  FormGroup1: FormGroup; FormGroup2: FormGroup; FormGroup3: FormGroup; FormGroup4: FormGroup; FormGroup5: FormGroup; FormGroup6: FormGroup; FormGroup7: FormGroup;
  userinp: any = {}; advancedOp;
  chooseOptions: any; caseDetails: any = {};
  minLoad: any; maxLoad: any; batteryObj = {}; batteryLoad = []; modalReference; bchart; batteryBrandList: any = [];
  batteryTypeList: any = [];
  isCapacityEditable: boolean = false; minCapacity; maxCapacity;
  minValue: number = 4; maxValue: number = 6; minValue1: number = 6; maxValue1: number = 10; plusminus: boolean = false;
  options: Options = {
    floor: 0,
    ceil: 23,
    // showTicks: true,
    // showTicksValues: true
  }; totalsum: any; batteryTimeInterval: any = [];
  technologyType: any = []; moduleManufacture: any = []; modelPowerRating: any = [];
  pcuManufactureList: any = []; pcuModelList: any = []; refVolObj: any = {};
  isdisabled: boolean = false; inpObj: any = {}; disableFirstStep: boolean = false;

  constructor(private _formBuilder: FormBuilder, public cstemapi: CstemapiService, private auth: AuthService, private myRoute: Router, private modalService: NgbModal, private cdRef: ChangeDetectorRef) {
    this.chooseOptions = this.auth.getOptions();
    // console.log(this.chooseOptions)

    this.auth.setIsGuest('false')

    if (this.chooseOptions.application == '2') {
      this.batteryDetails();
      this.getBatteryBrand();
      this.plusminusChange();
    }

    this.getTechnologyType();

  }

  ngOnInit() {
    this.formValidataion();
    this.setCaseDetails();
    this.setCommonDefaultValues();
  }

  ngAfterViewInit() {
    if (this.chooseOptions.application == '2') {
      this.batteryChart()
    }
  }

  formValidataion() {
    this.FormGroup1 = this._formBuilder.group({
      firstCtrl: ['', Validators.required]
    });
    this.FormGroup2 = this._formBuilder.group({
      secondCtrl: ['', Validators.required]
    });
    this.FormGroup3 = this._formBuilder.group({
      secondCtrl: ['', Validators.required]
    });
    this.FormGroup4 = this._formBuilder.group({
      secondCtrl: ['', Validators.required]
    });
    this.FormGroup5 = this._formBuilder.group({
      secondCtrl: ['', Validators.required]
    });
    this.FormGroup6 = this._formBuilder.group({
      secondCtrl: ['', Validators.required]
    });
    this.FormGroup7 = this._formBuilder.group({
      secondCtrl: ['', Validators.required]
    });
  }

  setCaseDetails() {
    if (this.chooseOptions.plantDesign == '1') {
      this.caseDetails['plantDesignType'] = 'cb'
    } else {

    }

    if (this.chooseOptions.application == '1') {
      this.caseDetails['applicationType'] = 'util';
    } else {
      if (this.chooseOptions.minigrid == '1') {
        this.caseDetails['applicationType'] = 'gcmg'
      } else {
        this.caseDetails['applicationType'] = 'ogmg'
      }
    }

    if (this.chooseOptions.financial == '1') {
      this.caseDetails['financialModelType'] = 'lcoe'
    }

    if (this.chooseOptions.financial == '2') {
      this.caseDetails['financialModelType'] = 'bid'
    }

    if (this.chooseOptions.financial == '3') {
      this.caseDetails['financialModelType'] = 'fit'
    }

    if (this.chooseOptions.technology == '1') {
      this.caseDetails['technologyType'] = 'pv'
    } else {
      this.caseDetails['technologyType'] = 'pvs'
    }

    if (this.chooseOptions.tracking == '1') {
      this.caseDetails['trackingType'] = 'fixed'
    }
    if (this.chooseOptions.tracking == '2') {
      this.caseDetails['trackingType'] = 'single'
    }
    if (this.chooseOptions.tracking == '3') {
      this.caseDetails['trackingType'] = 'duel'
    }
  }

  goForward(stepper: MatStepper) {
    stepper.next();
  }

  goBack(stepper: MatStepper) {
    stepper.previous();
  }

  stepchange(e, stepper: MatStepper) {
    // console.log(e)
    // console.log(stepper)
    if (e.selectedStep.label == 'simulate') {
      this.befSimulate(stepper)
    } else
      if (e.selectedStep.label == 'reset') {
        this.cstemapi.Swal.fire({
          title: '<span style="font-weight: normal; font-size: 24px;">Do you want to reset?</span>',
          text: '',
          type: 'warning',
          showCancelButton: true,
          cancelButtonColor: '#d33',
          cancelButtonText: 'Cancel',
          confirmButtonText: 'Yes',
          allowOutsideClick: false
        }).then((result) => {
          if (result.value) {
            this.myRoute.navigate(['/chooseoption']);
            // this.reload();
          } else {
            setTimeout(() => {
              stepper.selectedIndex = e.previouslySelectedIndex;
            });
          }
        })
      }
  }

  open(content) {
    let options: NgbModalOptions = {
      centered: true,
      backdrop: 'static'
    };
    this.modalReference = this.modalService.open(content, options);
  }

  close() {
    this.modalReference.close();
  }

  reload() {
    this.myRoute.routeReuseStrategy.shouldReuseRoute = () => false;
    this.myRoute.navigate([this.myRoute.url]);
  }

  setCommonDefaultValues() {
    this.userinp = {
      plantlife: this.defaultValues().plant_life_inp.default,
      duetosoiling: this.defaultValues().due_to_soiling_inp.default,
      electrical_losses_inp: this.defaultValues().electrical_losses_inp.default,
      avg_sunhours: this.defaultValues().avg_sunhours.default,
      maxsoc: this.defaultValues().battery_max_soc.default,
      minsoc: this.defaultValues().battery_min_soc.default,
      surface: this.defaultValues().surface_azimuth_angle_inp.default,
      tiltangle: parseFloat(this.auth.getUserLocation().lat.toFixed(6)),
      optimise: true,
      arrayheight: this.defaultValues().array_height_inp.default,
      groundclearence: this.defaultValues().ground_clearence_inp.default,
      techtype: '2',
      modulemanufacture: 'def',
      mmodel: 'def',
      pcumanufacture: 'def',
      pcumodel: 'def',
      battery_brand: 'def',
      battery_type: 'def',
      moduledatasheet: true,
      capital_module_price: this.defaultValues().capital_module_price.default,
      capital_pcu: this.defaultValues().capital_pcu.default,
      capital_battery: this.defaultValues().capital_battery.default,
      capital_land: this.defaultValues().capital_land.default,
      capital_mounting_structure: this.defaultValues().capital_mounting_structure.default,
      capital_power: this.defaultValues().capital_power.default,
      capital_civil: this.defaultValues().capital_civil.default,
      capital_preoperative: this.defaultValues().capital_preoperative.default,
      capital_miscellaneous: this.defaultValues().capital_miscellaneous.default,
      operation_cost: this.defaultValues().operation_cost.default,
      operation_escalation: this.defaultValues().operation_escalation.default,
      issub: false,
      subsidy_bulk_capital: this.defaultValues().subsidy_bulk_capital.default,
      feed_in_tarrif_fit: this.defaultValues().feed_in_tarrif_fit.default,
      target_bid: this.defaultValues().target_bid.default,
      tarrifonbuyofenergy: this.defaultValues().tarrifonbuyofenergy.default,
      loan_related_debt: this.defaultValues().loan_related_debt.default,
      loan_related_terms: this.defaultValues().loan_related_terms.default,
      loan_related_moratorium_period: this.defaultValues().loan_related_moratorium_period.default,
      loan_related_interest: this.defaultValues().loan_related_interest.default,
      loan_related_capital_interest: this.defaultValues().loan_related_capital_interest.default,
      return_equity_loan_term: this.defaultValues().return_equity_loan_term.default,
      return_equity_post_loan: this.defaultValues().return_equity_post_loan.default,
      taxes_income_tax_rate: this.defaultValues().taxes_income_tax_rate.default,
      taxes_alternative_tax: this.defaultValues().taxes_alternative_tax.default,
      depreciation_loan_term: this.defaultValues().depreciation_loan_term.default,
      for_utility_plant: this.defaultValues().for_utility_plant.default
    }

    if (this.chooseOptions.application == '2') {
      this.calCapacity();
    } else {
      this.userinp.capacity = this.defaultValues().capacity_inp.default;

      this.userinp.spacinglength = this.defaultValues().bspacing_length_inp.default;
      this.userinp.spacingbreadth = this.defaultValues().bspacing_breadth_inp.default;
    }
  }

  getTechnologyType() {
    var dObj = {
      userId: this.auth.getUserId()
    };

    var api = 'inputValues/getTechnologyType';

    this.cstemapi.cstemAPI(dObj).GetTechnologyType.subscribe(data => {
      this.cstemapi.printReqRes(dObj, data, api);
      let resData: any = data;
      if (resData.statusCode == 'S001') {
        this.technologyType = resData.technologyType;
        this.getModulemanufacturer(2);
      }
      if (resData.statusCode == 'E001') {
        this.cstemapi.Swal.fire('Error while getting Organization Type!', '', 'error');
      }

    }, (error) => {
      this.cstemapi.Swal.fire('Oops...', error, 'error');
    });
  }

  technologyChange() {
    if (this.userinp.techtype != 'def') {
      // console.log(this.userinp['techtype'])
      this.getModulemanufacturer(this.userinp['techtype']);
      this.userinp.modulemanufacture = 'def';
      this.userinp.mmodel = 'def';
      this.userinp.pcumodel = 'def';
      this.userinp['pcumanufacture'] = 'def';
    }
  }

  getModulemanufacturer(typeid) {
    this.flag = true;
    var dObj = {
      userId: this.auth.getUserId(),
      technologyTypeId: parseInt(typeid)
    };
    var api = 'inputValues/getManufacturer';
    this.cstemapi.cstemAPI(dObj).GetModulemanufacturesDetails.subscribe(data => {
      this.cstemapi.printReqRes(dObj, data, api);
      this.flag = false;
      let resData: any = data;
      if (resData.statusCode == 'S001') {
        this.moduleManufacture = resData.manufacturerTypeList;
      }
      if (resData.statusCode == 'E001') {
        this.cstemapi.Swal.fire('Error while getting Organization Type!', '', 'error');
      }

    }, (error) => {
      this.cstemapi.Swal.fire('Oops...', error, 'error');
    });
  }

  moduleManufactureChange() {
    // console.log(this.userinp['modulemanufacture'])
    if (this.userinp['modulemanufacture'] != 'def') {
      this.getModuleDetails();
    }
    this.userinp.mmodel = 'def';
  }

  getModuleDetails() {
    this.flag = true;
    var dObj = {
      userId: this.auth.getUserId(),
      technologyTypeId: parseInt(this.userinp['techtype']),
      manufactureId: parseInt(this.userinp['modulemanufacture'])
    };
    var api = 'inputValues/getModelDetails';
    this.cstemapi.cstemAPI(dObj).GetModelDetails.subscribe(data => {
      this.cstemapi.printReqRes(dObj, data, api);
      let resData: any = data;
      this.flag = false;
      if (resData.statusCode == 'S001') {
        this.modelPowerRating = resData.modelDetailsList;
      }
      if (resData.statusCode == 'E001') {
        this.cstemapi.Swal.fire('Error while getting Module details Type!', '', 'error');
      }

    }, (error) => {
      this.cstemapi.Swal.fire('Oops...', error, 'error');
    });
  }

  ModuleModelChange(id) {
    var mmodel = this.modelPowerRating.filter((item) => item.modelId == id);
    // console.log(mmodel)
    // this.moduleDetails = mmodel[0];
    this.userinp.modulelength = mmodel[0].length;
    this.userinp.modulebreadth = mmodel[0].breadth;
    this.userinp.module_rating_at_end = mmodel[0].degradationFirstYear;
    this.userinp.year_on_year_degradtion_rate = mmodel[0].degradationYearOnYear;
    this.userinp.moduleTypeName = mmodel[0].moduleTypeName;
    this.userinp.mountTypeName = mmodel[0].mountTypeName;
    this.userinp.moduletype = mmodel[0].moduleTypeId;
    this.userinp.mounttype = mmodel[0].mountTypeId;

    this.userinp['pcumanufacture'] = 'def';
    this.userinp.pcumodel = 'def';

    this.getPCUManufacture(mmodel[0].modelId);
  }

  getPCUManufacture(modelId) {
    this.flag = true;

    var dObj = {
      userId: this.auth.getUserId(),
      applicationTypeCode: this.caseDetails['applicationType'],
      moduleModelId: parseInt(modelId),
      plantCapacity: parseFloat(this.userinp['capacity']),
      tiltAngle: this.userinp.tiltangle,
      arrayHeight: this.userinp.arrayheight
    };
    var api = 'inputValues/getPCUModelDetails';
    /* manufacture list and model list is coming in same request */
    this.cstemapi.cstemAPI(dObj).GetPCUmodelDetails.subscribe(data => {
      this.cstemapi.printReqRes(dObj, data, api);
      let resData: any = data;
      if (resData.statusCode == 'S001') {
        this.flag = false;
        this.pcuManufactureList = resData.manufactureDetailsList;
        if (this.pcuManufactureList.length == 0) {
          setTimeout(() => {
            this.cstemapi.Swal.fire('No compatible PCUs found. Please retry with module of lesser power rating', '', 'warning');
          });
        }
      }
      if (resData.statusCode == 'E001') {
        this.flag = false;
        this.cstemapi.Swal.fire('Error while getting pcu manufacture list!', '', 'error');
      }

    }, (error) => {
      this.cstemapi.Swal.fire('Oops...', error, 'error');
    });
  }

  pcuManufactureChange(id) {
    // console.log(id)
    if (this.userinp['pcumanufacture'] != 'def') {
      var pmodel = this.pcuManufactureList.filter((item) => item.manufactureId == id);
      // console.log(pmodel)
      this.pcuModelList = pmodel[0].pcuModelDetailsList;
      this.userinp.pcumodel = 'def'
    }
  }

  setRefVoltage(id) {
    if (id != 'def') {
      var rv = this.pcuModelList.filter((item) => item.pcuModelId == id);
      this.refVolObj = rv[0];
      // console.log(this.refVolObj)

      this.userinp.noOfModuleStringsPerArray = this.refVolObj.noOfModuleStringsPerArray;
      this.userinp.noOfModulePerString = this.refVolObj.noOfModulePerString
      this.userinp.noOfArrayPerPcu = this.refVolObj.noOfArrayPerPcu;
      this.userinp.nPcu = this.refVolObj.nPcu
      this.userinp.nModPcu = this.refVolObj.nModPcu;
      this.userinp.originalPPlant = this.refVolObj.originalPPlant
      this.userinp.nPlant = this.refVolObj.nPlant;
      this.userinp.pPlant = this.refVolObj.pPlant
      this.userinp.dcScalingFactor = this.refVolObj.dcScalingFactor;
      this.userinp.dCWptoWRatio = this.refVolObj.dCWptoWRatio


      this.cstemapi.Swal.fire({
        title: '<span style="font-weight: normal; font-size: 24px;"> The approximate capacity is <span style="font-weight:bold">' + this.refVolObj.pPlant + ' MWp</span> Would you like to proceed?</span>',
        text: '',
        type: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancel',
        confirmButtonText: 'Yes, Continue',
        allowOutsideClick: false
        // reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.userinp.capacity = this.refVolObj.pPlant;
          this.isCapacityEditable = true;
          this.disableFirstStep = true;
          // if (this.chooseOptions.application == '2') {
          //   this.setMinMax();
          // }

        } else {
          this.reload();
          this.isCapacityEditable = false;
          this.disableFirstStep = false;
        }
      })
    }
  }

  getBatteryBrand() {
    var dObj = {
      userId: this.auth.getUserId()
    };

    var api = 'inputValues/getBatteryBrandDetails';
    this.cstemapi.cstemAPI(dObj).GetBatteryBrand.subscribe(data => {
      this.cstemapi.printReqRes(dObj, data, api);
      let resData: any = data;
      if (resData.statusCode == 'S001') {
        this.batteryBrandList = resData.batteryBrand;
      }
      if (resData.statusCode == 'E001') {
        this.cstemapi.Swal.fire('Error while getting Battery Brand!', '', 'error');
      }

    }, (error) => {
      this.cstemapi.Swal.fire('Oops...', error, 'error');
    });
  }

  onBatteryBrandChange() {
    // this.flag = true;
    var dObj = {
      userId: this.auth.getUserId(),
      batteryBrandId: this.userinp.battery_brand
    };
    var api = 'inputValues/getBatteryTypeDetails';
    this.cstemapi.cstemAPI(dObj).GetBatteryType.subscribe(data => {
      this.cstemapi.printReqRes(dObj, data, api);
      let resData: any = data;
      // this.flag = false;
      if (resData.statusCode == 'S001') {
        this.batteryTypeList = resData.batteryTypes;
      }
      if (resData.statusCode == 'E001') {
        this.cstemapi.Swal.fire('Error while getting Battery Type!', '', 'error');
      }

    }, (error) => {
      this.cstemapi.Swal.fire('Oops...', error, 'error');
    });
  }

  batteryDetails() {
    var capacity = 0.05;

    /* check with vinay */
    // this.minLoad = (((capacity / 100) * 1) * 1000).toFixed(3);
    // this.maxLoad = (((capacity / 100) * 60) * 1000).toFixed(3);

    /* checked with Harshid */
    this.minLoad = 0;
    this.maxLoad = 500;

    // var Load = [11.42348, 10.34006, 11.72297, 11.30661, 9.183312, 10.32546, 10.22319, 12.02713, 8.837952, 12.46044, 10.68338, 8.200117, 10.03064, 10.33451, 11.71245, 12.40142, 11.71245, 11.87344, 9.266, 13.30251, 9.537401, 0, 0, 0];
    var Load = [450, 450, 450, 450, 900, 13950, 13950, 15450, 1350, 450, 450, 450, 450, 450, 1350, 13350, 13350, 10000, 16500, 2625, 4125, 1500, 450, 1350];

    var final_load = [], iv, lvalue, lval;
    for (var i = 0; i < Load.length; i++) {

      /* lvalue is string and lval is float */
      lvalue = (((Load[i] / 1000) / 0.05) * capacity).toFixed(1)
      lval = parseFloat(lvalue)
      final_load.push(lval)
      iv = i + 1
      this.batteryObj['inp' + iv] = lval;

      if (Load.length == final_load.length) {
        this.batteryLoad = final_load;
      }
    }
  }

  batteryChart() {
    if (this.bchart) {
      this.bchart.destroy()
      this.bchart = null;
    }

    this.batteryLoad =
      [
        this.batteryObj['inp1'],
        this.batteryObj['inp2'],
        this.batteryObj['inp3'],
        this.batteryObj['inp4'],
        this.batteryObj['inp5'],
        this.batteryObj['inp6'],
        this.batteryObj['inp7'],
        this.batteryObj['inp8'],
        this.batteryObj['inp9'],
        this.batteryObj['inp10'],
        this.batteryObj['inp11'],
        this.batteryObj['inp12'],
        this.batteryObj['inp13'],
        this.batteryObj['inp14'],
        this.batteryObj['inp15'],
        this.batteryObj['inp16'],
        this.batteryObj['inp17'],
        this.batteryObj['inp18'],
        this.batteryObj['inp19'],
        this.batteryObj['inp20'],
        this.batteryObj['inp21'],
        this.batteryObj['inp22'],
        this.batteryObj['inp23'],
        this.batteryObj['inp24']
      ];

    this.bchart = Highcharts.chart('batteryChart', {
      title: {
        text: ''
      },
      xAxis: {
        title: {
          text: 'Hour',
          style: this.cstemapi.h_x_y_title_format
        },
        tickInterval: 1,
        labels: {
          style: this.cstemapi.h_x_y_format
        }
      },
      yAxis: {
        title: {
          text: 'Load curve (kW)',
          style: this.cstemapi.h_x_y_title_format
        },
        labels: {
          style: this.cstemapi.h_x_y_format
        }
      },
      plotOptions: {
        series: {
          label: {
            connectorAllowed: false
          },
          pointStart: 1
        }
      },
      tooltip: {
        style: this.cstemapi.h_x_y_tooltip_format.color,
        valueSuffix: ' kW'
      },
      series: [{
        showInLegend: false,
        name: 'Load curve',
        data: this.batteryLoad
      }],
      responsive: {
        rules: [{
          condition: {
            maxWidth: 500
          },
          chartOptions: {
            legend: {
              layout: 'horizontal',
              align: 'center',
              verticalAlign: 'bottom'
            }
          }
        }]
      }
    });
  }

  resetBatteryLoad() {
    this.batteryDetails();
    this.batteryChart();
    this.calCapacity();
  }

  clearBatteryLoad() {
    var iv, final_load = [];
    for (var i = 0; i < 24; i++) {

      iv = i + 1
      this.batteryObj['inp' + iv] = 0;
      final_load.push(0)
      if (final_load.length == 24) {
        this.batteryLoad = final_load;
        this.batteryChart();
        this.calCapacity();
      }

    }
  }

  subsidyChange() {
    if (!this.userinp.issub) {
      this.userinp.subsidy_bulk_capital = 0;
    }
  }

  calCapacity() {
    var fcap = this.batteryLoad.reduce(function (acc, val) { return acc + val; }, 0)
    var soilingLoss = 1 - (this.userinp.duetosoiling / 100);
    var electricalLoss = 1 - (this.userinp.electrical_losses_inp / 100)
    var calCapacity = fcap * 0.001 / (soilingLoss * electricalLoss * this.userinp.avg_sunhours)
    var finalcap: any = parseFloat(calCapacity.toFixed(4));
    // console.log(fcap)
    // console.log(calCapacity)
    // console.log(finalcap)
    this.userinp.capacity = finalcap;

    this.minCapacity = finalcap;
    this.maxCapacity = (finalcap * 3).toFixed(4);

    if (this.chooseOptions.minigrid == '1') {
      this.isCapacityEditable = false;
    } else {
      /* disable for ogmg type */
      this.isCapacityEditable = true;
    }

    /* check with Harshid */
    if (finalcap >= 0.01 && finalcap < 0.1) {
      this.userinp.spacinglength = 1;
      this.userinp.spacingbreadth = 1;
    }
    if (finalcap >= 0.1 && finalcap <= 0.5) {
      this.userinp.spacinglength = 10;
      this.userinp.spacingbreadth = 10;
    }
  }

  plusminusChange() {
    if (this.plusminus) {
      /* two time window */
      var vm = this;
      let difflogic = function () {
        var fdiff = vm.minValue - 0;
        var sdiff = 23 - vm.maxValue;
        if (fdiff > sdiff) {
          vm.minValue1 = vm.minValue - 1;
          vm.maxValue1 = vm.minValue;
        } else {
          vm.minValue1 = vm.maxValue;
          vm.maxValue1 = vm.maxValue + 1;
        }
      }

      if (this.minValue == 0 && this.maxValue == 23) {
        this.totalsum = this.maxValue - this.minValue;
        this.totalsum = this.totalsum + 1;
        this.plusminus = !this.plusminus;
      } else if (this.minValue1 >= this.minValue && this.minValue1 < this.maxValue || this.maxValue1 > this.minValue && this.maxValue1 < this.maxValue) {
        this.cstemapi.Swal.fire('Hey', 'Time window should not overlap with one another', 'warning');
        difflogic();
      } else if (this.minValue >= this.minValue1 && this.minValue < this.maxValue1 || this.maxValue < this.maxValue1 && this.maxValue > this.minValue1) {
        this.cstemapi.Swal.fire('Hey', 'Time window should not overlap with one another', 'warning');
        difflogic();
      }

      this.totalsum = (this.maxValue - this.minValue) + (this.maxValue1 - this.minValue1);
      if (this.minValue == 0 || this.minValue1 == 0) {
        this.totalsum = this.totalsum + 1;
      }
      this.batteryTimeInterval = [{
        start: this.minValue,
        end: this.maxValue
      }, {
        start: this.minValue1,
        end: this.maxValue1
      }];

    } else {
      /* one time window */
      this.batteryTimeInterval = [{
        start: this.minValue,
        end: this.maxValue
      }];
      this.totalsum = this.maxValue - this.minValue;
      if (this.minValue == 0) {
        this.totalsum = this.totalsum + 1;
      }
    }
  }

  befSimulate(stepper: MatStepper) {

    if (this.chooseOptions.application == '1') {
      if (this.userinp.modulemanufacture == 'def') {
        setTimeout(() => {
          stepper.selectedIndex = 1;
        });
        this.cstemapi.Swal.fire('Hey', 'Please select Module Manufacture', 'warning');
      } else if (this.userinp.mmodel == 'def') {
        setTimeout(() => {
          stepper.selectedIndex = 1;
        });
        this.cstemapi.Swal.fire('Hey', 'Please select Module Model', 'warning');
      } else if (this.userinp.pcumanufacture == 'def') {
        setTimeout(() => {
          stepper.selectedIndex = 1;
        });
        this.cstemapi.Swal.fire('Hey', 'Please select PCU Manufacture', 'warning');
      } else if (this.userinp.pcumodel == 'def') {
        setTimeout(() => {
          stepper.selectedIndex = 1;
        });
        this.cstemapi.Swal.fire('Hey', 'Please select PCU Model', 'warning');
      } else {

        this.batteryTimeInterval = [];
        this.batteryLoad = [];
        this.userinp.battery_brand = 0;
        this.userinp.battery_type = 0;
        this.userinp.minsoc = 0;
        this.userinp.maxsoc = 0;

        var vm = this;
        var rep = function () {
          if (vm.chooseOptions.financial == 3) {
            if (vm.userinp.feed_in_tarrif_fit == 0) {
              setTimeout(() => {
                stepper.selectedIndex = 3;
              });
              vm.cstemapi.Swal.fire('Hey', 'FIT should be greater than 0', 'warning');
            } else {
              vm.calSimulate(stepper);
            }
          } else if (vm.chooseOptions.financial == 2) {
            setTimeout(() => {
              stepper.selectedIndex = 3;
            });
            if (vm.userinp.target_bid == 0) {
              vm.cstemapi.Swal.fire('Hey', 'Bid should be greater than 0', 'warning');
            } else {
              vm.calSimulate(stepper);
            }
          } else {
            vm.calSimulate(stepper);
          }
        }
        if (this.userinp.issub) {
          if (this.userinp.subsidy_bulk_capital == 0) {
            setTimeout(() => {
              stepper.selectedIndex = 3;
            });
            this.cstemapi.Swal.fire('Hey', 'Bulk Capital should be greater than 0', 'warning');
          } else {
            rep();
          }
        } else {
          rep();
        }
      }

    } else {
      var vm = this;
      var rep1 = function () {
        if (vm.chooseOptions.financial == 3) {
          if (vm.userinp.feed_in_tarrif_fit == 0) {
            setTimeout(() => {
              stepper.selectedIndex = 4;
            });
            vm.cstemapi.Swal.fire('Hey', 'FIT should be greater than 0', 'warning');
          } else {
            vm.calSimulate(stepper);
          }
        } else if (vm.chooseOptions.financial == 2) {
          setTimeout(() => {
            stepper.selectedIndex = 4;
          });
          if (vm.userinp.target_bid == 0) {
            vm.cstemapi.Swal.fire('Hey', 'Bid should be greater than 0', 'warning');
          } else {
            vm.calSimulate(stepper);
          }
        } else {
          vm.calSimulate(stepper);
        }
      }

      if (this.userinp.modulemanufacture == 'def') {
        setTimeout(() => {
          stepper.selectedIndex = 1;
        });
        this.cstemapi.Swal.fire('Hey', 'Please select Module Manufacture', 'warning');
      } else if (this.userinp.mmodel == 'def') {
        setTimeout(() => {
          stepper.selectedIndex = 1;
        });
        this.cstemapi.Swal.fire('Hey', 'Please select Module Model', 'warning');
      } else if (this.userinp.pcumanufacture == 'def') {
        setTimeout(() => {
          stepper.selectedIndex = 1;
        });
        this.cstemapi.Swal.fire('Hey', 'Please select PCU Manufacture', 'warning');
      } else if (this.userinp.pcumodel == 'def') {
        setTimeout(() => {
          stepper.selectedIndex = 1;
        });
        this.cstemapi.Swal.fire('Hey', 'Please select PCU Model', 'warning');
      } else if (this.userinp.battery_brand == 'def' || this.userinp.battery_type == 'def') {
        setTimeout(() => {
          stepper.selectedIndex = 1;
        });
        this.cstemapi.Swal.fire('Hey', 'Battery Brand/Battery Type is Missing', 'warning');
      } else {
        if (this.userinp.issub) {
          if (this.userinp.subsidy_bulk_capital == 0) {
            setTimeout(() => {
              stepper.selectedIndex = 4;
            });
            this.cstemapi.Swal.fire('Hey', 'Bulk Capital should be greater than 0', 'warning');
          } else {
            rep1();
          }
        } else {
          rep1();
        }
      }
    }

  }

  calSimulate(stepper: MatStepper) {
    if (this.auth.getGuestUserId() != null) {
      this.auth.setIsGuest('true')
    }

    this.flag = true;
    this.isdisabled = true;

    this.inpObj = {
      lat: parseFloat(this.auth.getUserLocation().lat.toFixed(6)),
      lon: parseFloat(this.auth.getUserLocation().long.toFixed(6)),
      locationName: this.auth.getUserLocation().name,
      targetCapacity: parseFloat(this.userinp.capacity), /*********STEP 1 PLANT DETAILS ********** */
      plantLife: this.userinp.plantlife,
      tiltAngle: this.userinp.tiltangle,
      surfaceAzimuth: this.userinp.surface,
      arrayHeight: this.userinp.arrayheight,
      groundClearence: this.userinp.groundclearence,
      lengthSpacing: this.userinp.spacinglength,
      breadthSpacing: this.userinp.spacingbreadth,
      moduleTechnologyId: parseInt(this.userinp.techtype), /*********STEP 2 MODULE AND PCU ********** */
      moduleManufacturerId: parseInt(this.userinp.modulemanufacture),
      moduleModelId: parseInt(this.userinp.mmodel),
      moduleTypeId: parseInt(this.userinp.moduletype),
      mountTypeId: parseInt(this.userinp.mounttype),
      yearOnYearDegradationRate: this.userinp.year_on_year_degradtion_rate,
      moduleRatingAtEndOfFirstYear: this.userinp.module_rating_at_end,
      // pcuApplicationTypeId: parseInt(this.userinp.pcuapplication),
      pcuManufacturerId: parseInt(this.userinp.pcumanufacture),
      pcuModelId: parseInt(this.userinp.pcumodel),
      // vmid: this.userinp.pcureferencevoltage,
      soilingLossPercentage: this.userinp.duetosoiling,
      electricalLossPercentage: this.userinp.electrical_losses_inp,
      auxilaryConsumptionPercentage: this.userinp.for_utility_plant,
      moduleCost: this.userinp.capital_module_price, /*********STEP 3 COST AND O&M ********** */
      batteryCost: this.userinp.capital_battery,
      landCost: this.userinp.capital_land,
      mountingStructureCost: this.userinp.capital_mounting_structure,
      civilAndGeneralWorkCost: this.userinp.capital_civil,
      pcuCost: this.userinp.capital_pcu,
      powerEvacuationInfrastructureCost: this.userinp.capital_power,
      preOperativeExpences: this.userinp.capital_preoperative,
      miscCost: this.userinp.capital_miscellaneous,
      oAndMCost1Year: this.userinp.operation_cost,
      oAndMEscalationRate: this.userinp.operation_escalation,
      bulkCapital: this.userinp.subsidy_bulk_capital,
      fitPercentage: this.userinp.feed_in_tarrif_fit,
      bid: this.userinp.target_bid,
      debt: this.userinp.loan_related_debt, /*********STEP 4 FINANCIAL METRICS ********** */
      loanTerm: this.userinp.loan_related_terms,
      moratoriumPeriod: this.userinp.loan_related_moratorium_period,
      termLoanInterestRate: this.userinp.loan_related_interest,
      workingCapitalInterestRate: this.userinp.loan_related_capital_interest,
      depereciationDuringLoanTerm: this.userinp.depreciation_loan_term,
      retOnEquityDuringLoanTerm: this.userinp.return_equity_loan_term,
      retOnEquityPostLoanTerm: this.userinp.return_equity_post_loan,
      incomeTaxRate: this.userinp.taxes_income_tax_rate,
      minimumAlternateTaxRate: this.userinp.taxes_alternative_tax,
      batteryLoad: this.batteryLoad, /*********STEP 5 BATTERY ********** */
      timeInterval: this.batteryTimeInterval,
      socMin: this.userinp.minsoc,
      socMax: this.userinp.maxsoc,
      batteryBrandId: parseInt(this.userinp.battery_brand),
      batteryTypeId: parseInt(this.userinp.battery_type),
      albidoFactorId: this.auth.getAlbidoId(), /********* OTHERS ********** */
      userId: this.auth.getUserId(),
      caseDetails: this.caseDetails,
      isSubsidised: this.userinp.issub,
      tarrifOnBuyOfEnergy: parseInt(this.userinp.tarrifonbuyofenergy),
      trackingSystemCost: 0, /********* UNWANTED ********** */
      acceleratedDepreciationRate: 0,
      tarrifOnSaleOfEnergy: 0,
      noOfModuleStringsPerArray: this.userinp.noOfModuleStringsPerArray, /********* Extra added in new req ********** */
      noOfModulePerString: this.userinp.noOfModulePerString,
      noOfArrayPerPcu: this.userinp.noOfArrayPerPcu,
      nPcu: this.userinp.nPcu,
      nModPcu: this.userinp.nModPcu,
      originalPPlant: this.userinp.originalPPlant,
      nPlant: this.userinp.nPlant,
      pPlant: this.userinp.pPlant,
      dcScalingFactor: this.userinp.dcScalingFactor,
      dCWptoWRatio: this.userinp.dCWptoWRatio,
      optimizeCapacityFlag: this.userinp.optimise,
      demoCase: false
    }

    var api = 'compute/simulate'
    this.cstemapi.cstemAPI(this.inpObj).Simulate.subscribe(data => {
      this.cstemapi.printReqRes(this.inpObj, data, api);
      let resData: any = data;
      if (resData.statusCode == 'S001') {
        this.auth.savePlantId(resData.plantId);
        this.getPlantSummary(resData.plantId)
      } else {
        stepper.selectedIndex = stepper._steps.length - 3;
        this.isdisabled = false;
        this.auth.setIsGuest('false')
        this.flag = false;
        if (resData.statusCode == 'E001') {
          this.cstemapi.Swal.fire('Error while processing your request!', resData.statusMessage, 'error');
        }
        if (resData.statusCode == 'E005') {
          this.cstemapi.Swal.fire('Error', resData.statusMessage, 'error');
        }
      }

    }, (error) => {
      this.cstemapi.Swal.fire('Oops...', error, 'error');
    });
  }

  getPlantSummary(pid) {
    var dObj = {
      userId: this.auth.getUserId(),
      plantId: pid
    }
    var api = 'reports/getPlantSummaryReport';
    this.cstemapi.cstemAPI(dObj).GetPlantSummaryReport.subscribe(data => {
      let resData: any = data;
      this.cstemapi.printReqRes(dObj, data, api);
      if (resData.statusCode == 'S001') {
        this.flag = false;
        this.auth.savePlantSummaryReport(resData);
        var userLoc = {
          lat: resData.locLat,
          long: resData.locLong,
          name: resData.locationName
        }
        this.auth.saveUserLocation(userLoc);
        this.auth.saveAppCode(resData.caseDetailsEntity.applicationTypeCode)
        this.auth.saveCaseDetails(resData.caseDetailsEntity);
        this.myRoute.navigate(['/outputs'])
        // this.plantSummaryReport = resData;
        // this.chooseoption = resData.caseDetailsEntity;
        // if(resData.caseDetailsEntity.applicationTypeCode != 'util') {
        //   this.auth.saveDailyLoad(resData.batteryDetails.dailyLoad);
        // }
      }

      if (resData.statusCode == 'E001') {
        this.cstemapi.Swal.fire('Error!', 'Error while getting plant summary report', 'warning');
      }

    }, (error) => {
      this.cstemapi.Swal.fire('Oops...', error, 'error');
    });
  }

  defaultValues() {
    return {
      capacity_based: 'For a target DC plant capacity',
      area_based: 'For polygon area drawn in the map',
      grid_connected_utility_plant: '0.5 to 5000 MW',
      mini_grid: '10 to 500 kW',
      basic_viability: 'This includes determining the basic financial parameters, debt serviceability Levelised Cost of Energy (LCOE) and Internal Rate Return (IRR)',
      bid: 'This includes determining the basic financial viability and the profitability of the proposed bid',
      fit: 'This includes determining the basic financial viability and the profitability of the proposed Feed In Tariff',
      fixedpanel: 'Fixed module tilt (no tracking)',
      capacity_inp: {
        min: '0.5',
        max: '5000',
        default: '1'
      },
      capacity_inp_minigrid: {
        min: '0.01',
        max: '0.5',
        default: '0.01'
      },
      tilt_angle_inp: {
        min: 0,
        max: 90,
        tooltip: 'It is tilt of the PV array; typical consideration is to set this to be equal to the latitude of the location.'
      },
      surface_azimuth_angle_inp: {
        min: -180,
        max: 180,
        default: 0,
        tooltip: 'This parameter accounts for the orientation of the PV array with respect to the geographical south. Typical consideration in India is to orient the PV arrays due south'
      },
      plant_life_inp: {
        min: 5,
        max: 40,
        default: 25
      },
      reference_area_inp: {
        min: 1,
        max: 30,
        default: 5
      },
      user_defined_scaling_factor: {
        min: -180,
        max: 180,
        default: 0,
        tooltip: 'user_defined_scaling_factor'
      },
      array_height_inp: {
        min: 1.25,
        max: 1.5,
        default: 1.5,
        tooltip: 'The allowable structure height ranges from 1.25 to 1.5 m. This has been set in discussion with industry experts considering the ease of cleaning the panels'
      },
      ground_clearence_inp: {
        min: 0.5,
        max: 0.75,
        default: 0.5,
        tooltip: 'The ground clearance is the height at which the PV arrays are set to minimise soiling effects. Based on inputs with industry experts this is typically set at about 0.5 to 0.75 m from ground level'
      },
      bspacing_length_inp: {
        min: 1,
        max: 10,
        default: 10
      },
      bspacing_breadth_inp: {
        min: 1,
        max: 10,
        default: 10
      },
      due_to_soiling_inp: {
        min: 0,
        max: 50,
        default: 5
      },
      electrical_losses_inp: {
        min: 0,
        max: 25,
        default: 10
      },
      avg_sunhours: {
        min: 3,
        max: 6,
        default: 5
      },
      module_rating_at_end: {
        min: 50,
        max: 100,
        default: 97
      },
      year_on_year_degradtion_rate: {
        min: 0,
        max: 10,
        default: 0.67
      },
      for_utility_plant: {
        min: 0,
        max: 15,
        default: 1,
        tooltip: 'As a percentage of annual generation at the end of year 1 '
      },
      battery_load_peak: {
        min: 0,
        max: 1.5,
        default: 1
      },
      capital_module_price: {
        min: 0,
        max: 1000,
        default: 21,
        tooltip: 'Inclusive of custom clearing charges, transportation and unloading.'
      },
      capital_battery: {
        min: 0,
        max: 100000,
        default: 8000,
        tooltip: 'Overhaul costs not factored and are considered additionally based on discounted price as per year of replacement '
      },
      capital_land: {
        min: 0,
        max: 1000,
        default: 5,
        tooltip: 'Typically land deployed for these projects is barren in nature'
      },
      capital_mounting_structure: {
        min: 0,
        max: 1000,
        default: 30,
        tooltip: 'Includes structural and support material requirements'
      },
      capital_civil: {
        min: 0,
        max: 1000,
        default: 25,
        tooltip: 'Includes site preparation as such as levelling and mounting, building control room, approach roads, fencing or boundary wall, cable trenching, arranging water supply, lighting etc. General works include security of solar farm, setting up of power backup generator; yard lighting, earthing kits, etc'
      },
      capital_pcu: {
        min: 0,
        max: 1000,
        default: 30,
        tooltip: 'Includes all taxes, duties and major overhaul cost in 14th  year of operation'
      },
      capital_power: {
        min: 0,
        max: 1000,
        default: 40,
        tooltip: 'Includes DC and AC cabling costs between various equipments, metering and monitoring equipments  and all entities in the substation'
      },
      capital_preoperative: {
        min: 0,
        max: 1000,
        default: 35,
        tooltip: 'Includes transportation of equipment, Storage of equipment at site, insurance, taxes, duties, Interest During Construction (IDC), financing costs and other project management costs'
      },
      capital_miscellaneous: {
        min: 0,
        max: 1000,
        default: 30,
        tooltip: 'Includes contingency and any other expenses not covered in the above categories'
      },
      operation_cost: {
        min: 0,
        max: 1000,
        default: 6,
        tooltip: 'tooltip'
      },
      operation_escalation: {
        min: 0,
        max: 50,
        default: 5.72
      },
      subsidy_bulk_capital: {
        min: 0,
        max: 100,
        default: 0
      },
      feed_in_tarrif_fit: {
        min: 0,
        max: 100,
        default: 0
      },
      target_bid: {
        min: 0,
        max: 100,
        default: 0
      },
      loan_related_debt: {
        min: 0,
        max: 100,
        default: 70,
        tooltip: 'Share of capital cost considered as debt'
      },
      loan_related_terms: { /* change */
        min: 0,
        max: 25,
        default: 10
      },
      loan_related_moratorium_period: {  /* change */
        min: 0,
        max: 100,
        default: 1
      },
      loan_related_interest: {
        min: 0,
        max: 20,
        default: 8.5
      },
      loan_related_capital_interest: {
        min: 0,
        max: 20,
        default: 8.5
      },
      depreciation_loan_term: {
        min: 0,
        max: 50,
        default: 5.80
      },
      return_equity_loan_term: {
        min: 0,
        max: 100,
        default: 20
      },
      return_equity_post_loan: {
        min: 0,
        max: 100,
        default: 24
      },
      taxes_income_tax_rate: {
        min: 0,
        max: 50,
        default: 34
      },
      taxes_alternative_tax: {
        min: 0,
        max: 50,
        default: 20
      },
      battery_max_soc: {
        min: 0.1,
        max: 1,
        default: 0.8
      },
      battery_min_soc: {
        min: 0.1,
        max: 1,
        default: 0.3
      },
      referencevoltage: {
        tooltip: 'The PCU reference voltage is used to design the PV arrays in series and hence aid in designing the number of panels per PCU'
      },
      tarrifonbuyofenergy: {
        min: 0,
        max: 20,
        default: 6,
        tooltip: 'Tariff for buying energy from the grid'
      },
      pvModuleModel: {
        tooltip: 'Refers to the STC rating of the PV module'
      },
      pvInverter: {
        tooltip: 'PCU AC power Rating'
      }
    }
  }
}
